import { render, staticRenderFns } from "./bank.vue?vue&type=template&id=ec1cd7b6&scoped=true&"
import script from "./bank.vue?vue&type=script&lang=js&"
export * from "./bank.vue?vue&type=script&lang=js&"
import style0 from "./bank.vue?vue&type=style&index=0&id=ec1cd7b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec1cd7b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCol,VForm,VRow})
